<template>
  <div class="modal-backdrop">
    <div class="popup-content">
      <form @submit.prevent="submitFeedback" class="feedback_form">
        <p class="main_header">Насколько получилось выполнить “прошлое” задание?</p>
        <div class="form_wrapper">
          <div class="select_wrapper">
            <p>
              Насколько успешно выполнена задача?
            </p>
            <multiselect
                :disabled="isSaving"
                :options="[1, 2, 3, 4, 5]"
                v-model="form.successful_rate"
                :allow-empty="false"
                aria-label="Насколько успешно выполнена задача?"
                placeholder=""
                selectedLabel=""
                deselectLabel=""
                selectLabel=""
                name="effective_scale"
            />
          </div>
          <div class="select_wrapper">
            <p>
              Насколько эффективно вы применили силу эмоции?
            </p>
            <multiselect
                :disabled="isSaving"
                :options="[1, 2, 3, 4, 5]"
                v-model="form.effective_rate"
                :allow-empty="false"
                aria-label="Насколько эффективно вы применили силу эмоции?"
                placeholder=""
                selectedLabel=""
                deselectLabel=""
                selectLabel=""
                name="mood_scale"
            />
          </div>
          <custom-textarea
              :disabled="isSaving"
              :label="'Комментарий'"
              :labelWidth="28"
              v-model="form.comment"
              name="trigger_list"
          />
        </div>
        <button type="submit" class="btn btn-accent mr-10">
          Сохранить
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import CustomInput from "@/components/Forms/Fields/CustomInput.vue";
import {reactive} from "@vue/reactivity";
import {useStore} from "vuex";
import {ref} from "@vue/runtime-core";
import CustomTextarea from "@/components/Forms/Fields/CustomTextarea.vue";
import Multiselect from "vue-multiselect";
import {notify} from "@kyvg/vue3-notification";

export default {
  name: "PopUpTrackerFeedback",
  components: {Multiselect, CustomTextarea, CustomInput},
  props: {
    recordId: {
      type: Number,
      required: true,
    },
  },
  setup(props, context) {
    const store = useStore();
    const isSaving = ref(false);

    const form = reactive({
      task_id: null,
      successful_rate: null,
      effective_rate: null,
      comment: null,
    });

    const submitFeedback = () =>  {
      if (!form.successful_rate || !form.effective_rate) {
        notify({
          title: "Не все поля заполены",
          text: "Пожалуйста, оцените успешность выполнения задачи и эффективность использования эмоций",
          type: "warning"
        });
        return;
      }

      isSaving.value = true;
      store.dispatch("tracker/submitFeedback", {
        id: props.recordId,
        form: { ...form },
      }).then(() => {
        context.emit("close");
      })
        .finally(() => {
          isSaving.value = false;
        })
    }

    return {
      isSaving,
      form,
      submitFeedback,
    }
  }
}

</script>
<style scoped lang="scss">
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.7);
  overflow-y: auto;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
}

.popup-content {
  display: flex;
  padding: 20px;
  width: 40%;
  min-height: 450px;
  background-color: white;

  @media (max-width: 1024px) {
    width: 90%;
  }
}

.form_wrapper {
  width: 100%;
}

.select_wrapper {
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 10px;
}

.select_wrapper .multiselect {
  width: 100px;
}

.feedback_form {
  display: flex;
  margin: auto;
  align-items: center;
  flex-direction: column;
  row-gap: 15px;
}

.main_header {
  margin: 10px 0;
  font-weight: bold;
}
</style>